import AppRoute from "models/AppRoute"

const OffersRoute = new AppRoute({
    route: "/offers",
    navbar: true,
    authRequired: true,
})

export default OffersRoute
